<template>
  <div class="sidebar-left">
    <v-list dark dense flat color="#5bc0de" class="height-100">
      <template v-for="(item, i) in items">
        <v-layout v-if="item.heading" :key="i" row align-center>
          <v-flex xs12 class="px-5">
            <v-subheader v-if="item.heading">
              {{ item.heading }}
            </v-subheader>
          </v-flex>
        </v-layout>
        <v-divider
          v-else-if="item.divider"
          :key="i"
          dark
          class="my-3"
        ></v-divider>
        <v-list-item
          v-else
          :key="i"
          :class="item.link === $route.name ? 'highlight' : ''"
          @click="clicked(item)"
        >
          <v-list-item-action>
            <v-icon>
              {{ getIcon(item.icon) }}
            </v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>
              {{ item.name }}
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </template>
    </v-list>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { mdiAdjust } from "@mdi/js";

export default {
  name: "SidebarLeft",
  data: () => {
    return {
      mdiAdjust: mdiAdjust,
      items: [
        { heading: "Templates" },
        { icon: "mdiAdjust", text: "Templates", link: "Templates" },
        { divider: true },
        { heading: "Categories" },
        {
          icon: "mdiAdjust",
          text: "Category Grouping",
          link: "CategoryGroups"
        },
        { icon: "mdiAdjust", text: "Categories", link: "Categories" },
        { divider: true },
        { heading: "Units Of Measure" },
        { icon: "mdiAdjust", text: "UoM", link: "Uom" },
        { divider: true }
      ]
    };
  },

  computed: {
    ...mapGetters({})
  },

  mounted() {},

  methods: {
    clicked(item) {
      if (this.$route.name === item.link) {
        return;
      }
      this.$router.push({ name: item.link });
    },
    getIcon(icon) {
      return this[icon];
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.sidebar-left {
  text-align: left;
  color: #2c3e50;
}

.height-100 {
  height: 100vh;
}
.highlight {
  background-color: gray;
}
</style>
